<style lang="less" scoped>
.ws-panel-heading { 
    .head-actions { 
        .el-input { 
            width:auto!important;
        }
    }
    .el-tabs {
        display: inline-block;
        .el-tabs__header {
            border-bottom:1px dotted rgba(0,0,0,0.2);
        }
    }
}
</style>
<template>
<section class="ws-panel">
    <header class="ws-panel-heading ws-panel-heading-tabs">
        <div class="el-tabs el-tabs--card">
            <div class="el-tabs__header">
                <div class="el-tabs__nav-wrap">
                    <div class="el-tabs__nav-scroll">
                        <div class="el-tabs__nav">
                            <div v-for="item in tabItems" class="el-tabs__item"
                                :class="{'is-active': activeView == item.name}"
                                @click="tabClick(item)" v-if="item.show">{{item.tabName}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <div class="ws-panel-body">
        <!-- 路由外链 -->
        <transition> <keep-alive> <component
            v-bind:is="activeView" v-on:opentab="opentab"
            v-on:closetab="closetab"></component> </keep-alive> </transition>
    </div>
</section>
</template>
<script>
    import tabRoutes from '../config/tabroutes.js'
    export default {
        components: tabRoutes.tabComponent,
        props: {
            tabs : {
                type: Array
            },
            defaultView: { //默认的
                type: String
            }
        },
        data() {
            return {
                tabItems:[], //所有的TAB
                tabNames:[], //所有的名字
                activeView: null //当前激活的
            }
        },  
        mounted() {
            this.init();
        },
        computed: {
        },
        methods: {
            init() {
                this.tabItems = this.tabs;
                this.activeView = this.defaultView;
                for (var i = 0; i < this.tabItems.length; i++) {
                    var tabItem = this.tabItems[i];
                    this.tabNames[tabItem.name] = i;
                }
            },
            tabClick(item_) { //TAB点击事件
                this.activeView = item_.name;
                this.dispatch('tab-click', item_.name);
            },
            dispatch(eventName, itemName_, params) {
                let childs = this.$children;
                for(let i = 0; i < childs.length; i++) {
                    let childName = childs[i].$options.name;
                    if(childName == itemName_) {
                        childs[i].$emit(eventName, itemName_, params);
                    }
                }
            },
            opentab(title_, itemName_, params_) { //打开TAB页事件
                console.log('opentab');
                let itemIndex = this.tabNames[itemName_];
                this.tabItems[itemIndex].show = true;
                this.tabItems[itemIndex].tabName = title_;
                this.activeView = itemName_;
                this.dispatch('open-tab', itemName_, params_);
                this.$store.dispatch('tabpanelBuildParams', params_);
            },
            closetab(itemName_) { //关闭TAB事件
                console.log('closetab');
                let itemIndex = this.tabNames[itemName_];
                this.tabItems[itemIndex].show = false;
                //关闭后,默认显示第一个
                this.activeView = this.tabItems[0].name;
                this.dispatch('open-tab', this.activeView);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// tabpanel.vue?0be45e05